import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Globe, Users, Target } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide10Wave2({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-33">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-34">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-35">
          Optional Expansion Package
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-36">
          Wave 2:{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-37">
            Scale and optimize.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-5 flex flex-col justify-center gap-6" data-id="element-39">
          <p className="text-[var(--fg)] text-[clamp(1.1rem,1.5vw,1.5rem)] font-medium leading-relaxed" data-id="element-40">
            After Wave 1, use performance data to decide which campaigns to
            expand.
          </p>
          <div className="bg-[var(--brand-green)] text-white p-8 rounded-2xl shadow-lg" data-id="element-41">
            <TrendingUp className="w-8 h-8 text-[var(--brand-green-lighter)] mb-4" data-id="element-42" />
            <p className="font-bold text-2xl leading-snug" data-id="element-43">
              Wave 1 identifies what HCPs engage with.
              <br data-id="element-44" />
              <span className="text-[var(--brand-green-lighter)]" data-id="element-45">
                Wave 2 scales what works.
              </span>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-7 bg-[var(--surface)] rounded-2xl p-8 border border-black/5 flex flex-col" data-id="element-46">
          <h3 className="text-xl font-bold text-[var(--fg)] mb-6" data-id="element-47">
            Potential Wave 2 Assets
          </h3>

          <div className="grid grid-cols-2 gap-4 flex-1" data-id="element-48">
            <div className="bg-white p-5 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-49">
              <Target className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0 mt-0.5" data-id="element-50" />
              <div data-id="element-51">
                <p className="font-bold text-[var(--fg)]" data-id="element-52">Additional Masters</p>
                <p className="text-sm text-[var(--muted)] font-medium mt-1" data-id="element-53">
                  2 additional teaser masters and 1 frequent prescriber trailer.
                </p>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-54">
              <Users className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0 mt-0.5" data-id="element-55" />
              <div data-id="element-56">
                <p className="font-bold text-[var(--fg)]" data-id="element-57">Event Activation</p>
                <p className="text-sm text-[var(--muted)] font-medium mt-1" data-id="element-58">
                  1 webinar or congress activation Snak.
                </p>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-59">
              <Globe className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0 mt-0.5" data-id="element-60" />
              <div data-id="element-61">
                <p className="font-bold text-[var(--fg)]" data-id="element-62">
                  Local & Retargeting
                </p>
                <p className="text-sm text-[var(--muted)] font-medium mt-1" data-id="element-63">
                  Local market adaptations and retargeting Snaks based on
                  engagement data.
                </p>
              </div>
            </div>
            <div className="bg-white p-5 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-64">
              <TrendingUp className="w-5 h-5 text-[var(--brand-green)] flex-shrink-0 mt-0.5" data-id="element-65" />
              <div data-id="element-66">
                <p className="font-bold text-[var(--fg)]" data-id="element-67">Optimization</p>
                <p className="text-sm text-[var(--muted)] font-medium mt-1" data-id="element-68">
                  Rep-triggered follow-up Snaks and monthly
                  reporting/recommendations.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}